export const NodeIdAttrName = 'nodeId';
export const NodeIdRootValue = 'root';
export const NodeIdMissingValue = 'missing';
